import { MEDIA } from "../data/content";
import Reveal from "./Reveal";

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 lg:py-40 px-6 md:px-12 lg:px-24 bg-beige"
    >
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
        {/* Portrait */}
        <Reveal className="lg:col-span-5">
          <div className="relative group max-w-sm mx-auto lg:mx-0">
            <div className="absolute -top-4 -left-4 w-20 h-20 border-t border-l border-gold z-10" />
            <div className="absolute -bottom-4 -right-4 w-20 h-20 border-b border-r border-gold z-10" />
            <div className="overflow-hidden bg-beige-200 aspect-[2/3]">
              <img
                src={MEDIA.founder}
                alt="Raj Goyal"
                className="w-full h-full object-cover object-center scale-100 group-hover:scale-105 transition-transform duration-700"
                data-testid="founder-image"
              />
            </div>
            <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-royal/90 to-transparent p-6">
              <p className="font-display text-2xl text-beige-light">Raj Goyal</p>
              <p className="font-accent text-sm uppercase tracking-[0.22em] text-gold mt-1">
                Founder · Developer · Investor
              </p>
            </div>
          </div>
        </Reveal>

        {/* Text */}
        <div className="lg:col-span-7">
          <Reveal>
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-12 bg-gold" />
              <span className="font-accent text-sm uppercase tracking-[0.28em] text-gold">
                About Raj
              </span>
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-display text-royal text-4xl md:text-5xl lg:text-6xl leading-[1.08]">
              Three decades of building{" "}
              <span className="italic text-gold-gradient">empires</span> across
              continents.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 text-royal/75 leading-relaxed text-lg md:text-xl max-w-2xl">
              Raj Goyal is an accomplished real estate developer, investor and
              entrepreneur with over 30 years of experience across a diverse
              portfolio of industries — including real estate, commodity trading,
              manufacturing, hospitality, and sales &amp; marketing.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 text-titanium leading-relaxed text-lg max-w-2xl">
              Originally from humble beginnings and a family of Delhi, India, Raj
              immigrated to the United States after earning his bachelor's degree
              in accounting from Delhi University and a Diploma in Sales and
              Marketing Management — at the age of 20.
            </p>
          </Reveal>

          <Reveal delay={0.2}>
            <div className="mt-10 border-l-2 border-gold pl-6 md:pl-8 py-2">
              <p className="font-accent text-sm uppercase tracking-[0.24em] text-gold mb-3">
                Raj's Mission — Building a Better Future Through Strategic Impact
              </p>
              <blockquote className="font-display italic text-2xl md:text-3xl text-royal leading-snug">
                "Driven by a passion for impact and a philanthropic spirit, Raj
                is committed to leaving the world better than he found it —
                empowering communities and organizations to achieve stability,
                prosperity, growth, and operational excellence."
              </blockquote>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default About;
